import { c as _c } from "react/compiler-runtime";
import { Skeleton_OLD } from '@7f-ui/components/skeleton_old';
export function AppSkeletonOfferItemGroup() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton_OLD.Item className="col-span-5 mb-1 h-3 sm:mb-3 sm:h-4" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Skeleton_OLD className="gap-y-2 pt-2 pb-6 last:pb-0 sm:pb-10">{t0}<div className="col-span-12 space-y-2 sm:space-y-4"><SkeletonListItem /></div></Skeleton_OLD>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function SkeletonListItem() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton_OLD.Item className="col-span-4 mb-8 h-4" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="grid sm:hidden">{t0}<div className="col-span-12 flex justify-between"><div className="w-full space-y-2"><Skeleton_OLD.Item className="h-3 w-3/12" /><Skeleton_OLD.Item className="h-3 w-5/12" /></div><Skeleton_OLD.Item className="h-10 w-5/12" /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="rounded-xl border border-sand p-6 sm:p-9 sm:pr-16">{t1}<div className="hidden sm:block"><div className="col-span-12 flex items-center justify-between"><div className="w-full space-y-6"><Skeleton_OLD.Item className="h-4 w-3/12" /><Skeleton_OLD.Item className="h-5 w-5/12" /></div><Skeleton_OLD.Item className="h-10 w-5/12" /></div></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}